import DefaultCover from './DefaultCover/DefaultCover';
import MarshCover from './MarshCover/MarshCover';
import AonCover from './AonCover/AonCover';
import IProfileCover from './IProfileCover/IProfileCover';

export default { DefaultCover, MarshCover, AonCover, IProfileCover };
